import React from "react";
import { Box, Typography, Button } from "@mui/material";
import lastBg from "../../../assets/images/home/lastBG.png";
import lastbgcentrum from '../../../assets/centrum_assets/design/index/lastBGmin.png';
import LinesDecor from "../../components/LinesDecor";
import BlueLine from "../../components/BlueLine";

const SectionSeven = () => {
  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      <Box
        component="img"
        src={lastBg}
        alt="Background Desktop"
        sx={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
          display: "block",
          mt: { lg: -8.5 },
          "@media (max-width:1150px)": {
            display: "none",
          }
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "5%",
          transform: "translateY(-50%)",
          width: "45%",
          color: "#002349",
          display: "block",
          "@media (max-width:1150px)": {
            display: "none",
          }
        }}
      >
         <Box
          sx={{
            position: "absolute",
            mx: 8,
            transform: "translateY(-50%)",
           
          }}
        >
        <Typography
          variant="h5"
          sx={{ mb: 0.5, fontWeight: "bold", color: "#00b5e2" }}
        >
          JOIN OUR TEAM
        </Typography>

        <Typography
          variant="h2"
          sx={{
            color: "#0a1a3b",
            fontWeight: 800,
            mb: 2,
            lineHeight: 1.2,
            letterSpacing: "4px",
          }}
        >
          EXPLORE YOUR <br /> POSSIBILITIES
        </Typography>

        <BlueLine mt={2}>
          <Typography
            sx={{
              color: "#5f5f5f",
              lineHeight: 2.3,
              mb: 5,
              px: 5,
              maxWidth: 530,
              fontSize: '1.6rem',
            }}
          >
            Centrum Fuel is always on the lookout for new talent who are interested in exploring current opportunities and taking their career to the next level. 
            If you have a passion for what we do, then we want you!
          </Typography>

          <Button
            variant="contained"
            onClick={() => window.open("https://www.facebook.com/centrumfuel", "_blank")}
            sx={{
              borderRadius: 20,
              fontWeight: 600,
              px: 5,
              letterSpacing: "3px",
              fontSize: "1.4rem",
              backgroundColor: "#00b5e2",
              "&:hover": {
                backgroundColor: "#009ecb",
              },
            }}
          >
            LEARN MORE
          </Button>
        </BlueLine>
        </Box>
      </Box>

      <Box
        component="img"
        src={lastbgcentrum}
        alt="Mobile Background"
        sx={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
          display: "none",
          "@media (max-width:1150px)": {
            display: "block",
          }
        }}
      />

      <Box
        sx={{
          py: 5,
          px: 5,
          backgroundColor: "#fff",
          color: "#0c1a36",
          textAlign: "left",
          display: "none",
          "@media (max-width:1150px)": {
            display: "block",
          }
        }}
      >
        <Typography
          sx={{ fontSize: '2rem', mb: 0.5, fontWeight: "bold", color: "#00b5e2" }}
        >
          JOIN OUR TEAM
        </Typography>

        <Typography
          variant="h2"
          sx={{
            color: "#0a1a3b",
            fontWeight: 800,
            mb: 2,
            lineHeight: 1.2,
            letterSpacing: "4px",
          }}
        >
          EXPLORE YOUR <br /> POSSIBILITIES
        </Typography>

        <BlueLine>
          <Typography
            sx={{
              color: "#5f5f5f",
              lineHeight: 2,
              width: "100%", 
              mb: 2,
              fontSize: '2rem',
              // ml: 0 
            }}
          >
            Centrum Fuel is always on the lookout for new talent who are interested in exploring current opportunities and taking their career to the next level. 
            If you have a passion for what we do, then we want you!
          </Typography>

          <Button
            variant="contained"
            onClick={() => window.open("https://www.facebook.com/centrumfuel", "_blank")}
            sx={{
              borderRadius: 20,
              fontWeight: 600,
              px: 4,
              mb: 3,
              letterSpacing: 4,
              fontSize: "1.9rem",
              backgroundColor: "#00b5e2",
              "&:hover": {
                backgroundColor: "#009ecb",
              },
            }}
          >
            LEARN MORE
          </Button>
        </BlueLine>
      </Box> 

      <LinesDecor
        greenMt={{ xl: -6, lg: -5, md: -4, sm: -2, xs: 1 }}
        blueMt={{ xl: -0.3, lg: 1, md: 2, sm: 1, xs: 3 }}
      />
    </Box>
  );
};

export default SectionSeven;